<template>
  <v-chip
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template
      v-for="(_, name) in $slots"
      #[name]
    >
      <slot :name="name" />
    </template>
  </v-chip>
</template>

<script>
export default {
  name: "EkitabuChip",
  inheritAttrs: false,
};
</script>
